export default "__VITE_ASSET__CFIIpnCT__"